import { render, staticRenderFns } from "./LinkedCompSection.vue?vue&type=template&id=39bd5e30&scoped=true&"
import script from "./LinkedCompSection.vue?vue&type=script&lang=js&"
export * from "./LinkedCompSection.vue?vue&type=script&lang=js&"
import style0 from "./LinkedCompSection.vue?vue&type=style&index=0&id=39bd5e30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd5e30",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkedCompSlider: require('/home/bitrix/frontend/components/compilations/LinkedCompSlider.vue').default,LinkedCompList: require('/home/bitrix/frontend/components/compilations/LinkedCompList.vue').default})
